const hotel = {
  availableMealPlans: "Διαθέσιμα προγράμματα γευμάτων", // translated
  availableRoomsTypes: "Διαθέσιμοι τύποι δωματίων", // translated
  cancellationPolicy: "Πολιτική ακύρωσης", // translated
  cancellationRules: "Κανόνες ακύρωσης", // translated
  freeCancellationAvailable: "Δωρεάν ακύρωση διαθέσιμη", // translated
  nonRefundable: "Μη Επιστρέψιμη", // translated
  priceFor: "Τιμή για", // translated
  nights: "νύχτες", // translated
  totalPrice: "Συνολικό ποσό", // translated
  seeAvailability: "Δείτε Διαθεσιμότητα", // translated
  myProfile: "Το ΠΡΟΦΙΛ μου", // translated
  travelTrust: "Travel Trust", // translated
  signIn: "Συνδεθείτε", // translated
  searchNow: "Ψάξε τώρα", // translated
  policy: "Πολιτική", // translated
  cxlRules: "Κανόνες CXL", // translated
  room: "δωμάτιο", // translated
  cxlPolicy: "Πολιτική CXL", // translated
  beddingType: "Τύπος κρεβατιού", // translated
  hotelName: "Όνομα ξενοδοχείου", // translated
  reservationDate: "Ημερομηνία κράτησης", // translated
  maxPax: "Μαξ Παξ", // translated
};


export default hotel;
